// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__1dYVD","icon":"Placeholder_icon__Dw9g0","text":"Placeholder_text__1VyDB"};